import { makeAutoObservable } from "mobx";
import { OFFLINE, ONLINE } from "../models/constants";
import MqttService from "../services/MqttService";
import NotificationService from "../services/NotificationService";

export class NotificationManagerStore{

    enabled: boolean
    onlineStatus: boolean

    constructor(){
        makeAutoObservable(this)
        this.enabled = NotificationService.getNotificationPermission()
        this.onlineStatus = true
    }

    toggleNotification(){
        this.enabled = !this.enabled
        NotificationService.toggleNotificationPermission(this.enabled)
    }

    toggleOnlineStatus(){
        this.onlineStatus = !this.onlineStatus
        if(this.onlineStatus)
         MqttService.updateStatus(ONLINE)
        else
         MqttService.updateStatus(OFFLINE)
    }
}